"use client";
import React, { useState } from "react";
import MainBanner from "./MainBanner";
import { JoinSteps } from "./JoinSteps";
import ProffesionalForm from "./ProffesionalForm";
import KeyPointsProffesional from "./KeyPointsProffesional";
import { Box, Grid, Typography } from "@mui/material";
import ProfessionalReview from "./ProfessionalReview";
import "./index.css";
import OpportunityCards from "./OpportunityCards";
import LanguageButton from "./LanguageButton";

const contentGutter = {
  width: "100%",
  maxWidth: "min(92%, 1220px)",
  marginLeft: "auto",
  marginRight: "auto",
  paddingX: { xs: 2, sm: 3 },
  boxSizing: "border-box" as const,
};

export const RegisterProfessional = () => {
  const [selected, setSelected] = useState(true);

  const brandSalonTym = (
    <>
      <Box component="span" sx={{ color: "#dff6e8" }}>
        Salon
      </Box>
      <Box component="span" sx={{ color: "#f4e8a6" }}>
        Tym
      </Box>
    </>
  );

  return (
    <Box
      sx={{
        background:
          "linear-gradient(180deg, rgba(245, 251, 247, 0.98) 0%, #fafafa 100%)",
        pb: { xs: 10, sm: 2 },
      }}
    >
      <LanguageButton selected={selected} setSelected={setSelected} />
      <Box
        sx={{
          background:
            "linear-gradient(135deg, #123524 0%, #1f7a4d 45%, #0f2418 100%)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            whiteSpace: "nowrap",
            width: "100%",
            overflow: "hidden",
            position: "absolute",
            background: "rgba(18, 53, 36, 0.92)",
            zIndex: 100,
            display: "flex",
            py: 1,
            borderBottom: "1px solid rgba(255,255,255,0.08)",
          }}
        >
          <Typography
            variant="body2"
            className="register-marquee-text"
            sx={{
              fontSize: { xs: "0.8rem", sm: "0.95rem" },
              lineHeight: 1.5,
              color: "#fff",
              textWrap: "nowrap",
              px: 2,
            }}
          >
            {selected
              ? "Trusted by 1,000+ professionals nationwide. Join us for superior service and unwavering support."
              : "देश भर में 1,000+ पेशेवरों का भरोसा। बेहतरीन सेवा और समर्थन के लिए हमसे जुड़ें।"}
          </Typography>
        </Box>
        <Box
          sx={{
            ...contentGutter,
            position: "relative",
            pt: { xs: 7, sm: 8 },
            pb: { xs: 3, sm: 4 },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "center",
            alignItems: { xs: "center", md: "flex-start" },
            gap: { xs: 2, md: 3 },
          }}
        >
          <Box
            sx={{
              flex: { md: "0 0 auto" },
              width: "100%",
              maxWidth: { xs: "100%", md: "min(520px, 100%)" },
              textAlign: "center",
            }}
          >
            <MainBanner selected={selected} />
          </Box>
          <Box
            sx={{
              flex: { md: "0 0 auto" },
              width: "100%",
              maxWidth: { xs: "100%", sm: "460px" },
              mt: { xs: 0, md: 2 },
              alignSelf: { xs: "center", md: "flex-start" },
            }}
          >
            <ProffesionalForm selected={selected} />
          </Box>
        </Box>
      </Box>
      <Grid container sx={{ ...contentGutter, py: { xs: 2, sm: 3 } }}>
        <OpportunityCards selected={selected} />
      </Grid>

      <JoinSteps selected={selected} />
      <Grid container sx={{ ...contentGutter, py: 1 }}>
        <Typography
          variant="h4"
          component="h2"
          sx={{
            textAlign: "left",
            fontWeight: 700,
            py: 2,
            fontSize: { xs: "1.35rem", sm: "1.75rem" },
            marginBottom: { xs: "8px", sm: "16px" },
            color: "#123524",
          }}
          className="join-professional-steps"
        >
          {selected ? (
            <>
              Why join {brandSalonTym}?
            </>
          ) : (
            <>
              {brandSalonTym} से क्यों जुड़ें?
            </>
          )}
        </Typography>
      </Grid>
      <Box sx={{ ...contentGutter, pb: 2 }}>
        <KeyPointsProffesional selected={selected} />
      </Box>
      <Grid container sx={contentGutter}>
        <Grid item xs={12}>
          <ProfessionalReview selected={selected} />
        </Grid>
      </Grid>
    </Box>
  );
};
